var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatchservices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "carbon:batch-job"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46 37.375V34.5H42.9798C42.7944 33.6002 42.4371 32.7445 41.9276 31.9801L44.0694 29.8382L42.0368 27.8056L39.8949 29.9474C39.1305 29.4377 38.2749 29.0804 37.375 28.8952V25.875H34.5V28.8952C33.6002 29.0806 32.7445 29.4379 31.9801 29.9474L29.8382 27.8056L27.8056 29.8382L29.9474 31.9801C29.4377 32.7445 29.0804 33.6001 28.8952 34.5H25.875V37.375H28.8952C29.0806 38.2748 29.4379 39.1304 29.9474 39.8949L27.8056 42.0368L29.8382 44.0694L31.9801 41.9276C32.7445 42.4373 33.6001 42.7946 34.5 42.9798V46H37.375V42.9798C38.2748 42.7944 39.1305 42.4371 39.8949 41.9276L42.0368 44.0694L44.0694 42.0368L41.9276 39.8949C42.4373 39.1305 42.7946 38.2749 42.9798 37.375H46ZM35.9375 40.25C33.5599 40.25 31.625 38.3151 31.625 35.9375C31.625 33.5599 33.5599 31.625 35.9375 31.625C38.3151 31.625 40.25 33.5599 40.25 35.9375C40.25 38.3151 38.3151 40.25 35.9375 40.25ZM28.75 24.4375H17.25C16.4875 24.4375 15.7562 24.1346 15.2171 23.5954C14.6779 23.0563 14.375 22.325 14.375 21.5625V5.75C14.375 4.9875 14.6779 4.25623 15.2171 3.71707C15.7562 3.1779 16.4875 2.875 17.25 2.875H28.75C29.5125 2.875 30.2438 3.1779 30.7829 3.71707C31.3221 4.25623 31.625 4.9875 31.625 5.75V21.5625C31.625 22.325 31.3221 23.0563 30.7829 23.5954C30.2438 24.1346 29.5125 24.4375 28.75 24.4375ZM17.25 21.5625H28.75V5.75H17.25V21.5625Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.4375 30.1875H11.5C10.7375 30.1875 10.0062 29.8846 9.46707 29.3454C8.9279 28.8063 8.625 28.075 8.625 27.3125V10.0625H11.5V27.3125H24.4375V30.1875Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.6875 35.9375H5.75C4.16444 35.9375 2.875 34.6481 2.875 33.0625V15.8125H5.75V33.0625H18.6875V35.9375Z",
    fill: "#909090"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchservices);
export default __webpack_public_path__ + "static/media/batchservices.b1c01017a1291f1c5a7a2d849d9706bd.svg";
export { ForwardRef as ReactComponent };